class QuickBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (!this.els?.button?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.button.elements.forEach(buttonEl => {
      this.listeners.add(buttonEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    this.removeActive()

    const currentButton = event.currentTarget
    const newProductID = currentButton.dataset.id
    const newPrice = currentButton.querySelector('[data-quick-buy-price]')
      .innerHTML

    currentButton.classList.add('prd-VariantDrawer_Button-active')
    this.els.price.element.innerHTML = newPrice
    this.els.formID.element.value = newProductID
    this.els.submit.element.disabled = false
    this.els.submitText.element.innerHTML =
      window.theme.strings.product.addToCart
  }

  removeActive () {
    this.els.button.elements.forEach(buttonEl => {
      buttonEl.classList.remove('prd-VariantDrawer_Button-active')
    })
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
